import { ReactNode } from 'react'
import { Block } from 'ui-kit/blocks'
import { Companies } from 'routes/components/Features/Companies'
import classes from './SolutionCompanies.module.scss'

export const SolutionCompanies = ({
  title,
  subtitle,
}: {
  title?: string
  subtitle?: ReactNode
}) => {
  return (
    <Block
      as={'section'}
      variant={'shadowMob'}
      pad={'baseMob'}
      divider={'mobile'}
      className={classes.section}
    >
      <Companies title={title} subtitle={subtitle} />
    </Block>
  )
}
